import {
defineCustomElement,
MediaSpeedRadioGroupElement
} from "vidstack/elements";

defineCustomElement(MediaSpeedRadioGroupElement);